import { getFirestore } from "firebase/firestore";
import { initializeApp } from "firebase/app";
const firebaseConfig = {
  apiKey: process.env.REACT_APP_Firestore_API_Secret_Key,
  authDomain: process.env.REACT_APP_Firestore_authDomain_Secret_Key,
  projectId: process.env.REACT_APP_Firestore_projectId_Secret_Key,
  storageBucket: process.env.REACT_APP_Firestore_storageBucket_Secret_Key,
  messagingSenderId: process.env.REACT_APP_Firestore_messagingSenderId_Secret_Key,
  appId: process.env.REACT_APP_Firestore_appId_Secret_Key
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
